import React from "react";
import { IImageProps } from "../../models";

const Image: React.FC<IImageProps> = ({ src, alt, onClick, loading = "lazy", ...props }: IImageProps) => {
	return <img src={src} loading={loading} alt={alt} onClick={onClick} {...props} />;
};
Image.displayName = "Image";
export default Image;
